import './List.scss'

import classNames from 'classnames'
import React from 'react'

export interface ListProps {
  className?: string
  divider?: DividerProps
  children?: React.ReactNode
}

export interface DividerProps {
  position?: DividerPosition
  afterLast?: boolean
}

export interface DividerPosition {
  left?: string
  right?: string
}

export default function List({ children, divider, className }: ListProps): JSX.Element {
  const dividerStyle = getDividerStyle(divider)

  return (
    <ul className={classNames('List ListContainer', className)} style={dividerStyle}>
      {children}
    </ul>
  )
}

const getDividerStyle = (dividerProps?: DividerProps): React.CSSProperties => {
  let dividerStyle: React.CSSProperties =
    dividerProps !== undefined
      ? ({ '--divider-content': '""' } as React.CSSProperties)
      : ({ '--divider-content': 'none' } as React.CSSProperties)
  dividerStyle = {
    ...dividerStyle,
    '--divider-position-left': '1rem',
    '--divider-position-right': '1rem',
  } as React.CSSProperties
  if (dividerProps !== undefined && dividerProps.position !== undefined) {
    if (dividerProps.position.left !== undefined) {
      dividerStyle = {
        ...dividerStyle,
        '--divider-position-left': dividerProps.position.left as React.CSSProperties,
      } as React.CSSProperties
    }

    if (dividerProps.position.right !== undefined) {
      dividerStyle = {
        ...dividerStyle,
        '--divider-position-right': dividerProps.position.right as React.CSSProperties,
      } as React.CSSProperties
    }
  }

  if (dividerProps !== undefined && Boolean(dividerProps.afterLast)) {
    dividerStyle = {
      ...dividerStyle,
      '--last-of-type-divider-content': '""',
    } as React.CSSProperties
  }

  return dividerStyle
}
